module.exports = __webpack_public_path__ + "static/img/54.3b35037.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/54.png
// module id = D8Em
// module chunks = 0